const initialState = true;

const importantMessageShownReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_IMPORTANT_MESSAGE_SHOWN':
      return false;
    case 'RESET_IMPORTANT_MESSAGE_SHOWN':
      return true;
    default:
      break;
  }
  return state;
}

export default importantMessageShownReducer;